// jsBridgeInterface.js
/* eslint-disable no-console */
'use client';
'use strict';

import { resourceUrlConfigMaps } from '../action/updateConfigurations.js';
import { getIsOnWebviewApp } from '../resource/getUserAgent.js';

const isOnWebviewApp = getIsOnWebviewApp();

if (isOnWebviewApp) {
  console.debug('jsBridgeInterface isOnWebviewApp');

  if (!window.__JS_BRIDGE_READY_PROMISE__) {
    window.__JS_BRIDGE_READY_PROMISE__ = new Promise(resolve => {
      window.__JS_BRIDGE_READY_RESOLVE__ = resolve;
    });
  }

  window.__WEBVIEW_READY_PROMISE__ = new Promise(resolve => {
    window.__WEBVIEW_READY_RESOLVE__ = resolve;
  });

  const getRefreshToken = async () => {
    try {
      const meData = await window.getDbData?.('me');
      return meData?.refreshToken ?? null;
    } catch (_) {
      //
    }
    return null;
  };

  const setResourceUrl = remoteConfig => {
    if (remoteConfig) {
      console.debug('jsBridgeInterface setResourceUrl start');
      const resourceUrl = {};
      Object.keys(resourceUrlConfigMaps).forEach(key => {
        if (remoteConfig[key]) {
          resourceUrl[resourceUrlConfigMaps[key]] = remoteConfig[key];
        }
      });

      if (Object.keys(resourceUrl).length) {
        if (!window.__RESOURCE_URL__) window.__RESOURCE_URL__ = {};

        window.__RESOURCE_URL__ = {
          ...window.__RESOURCE_URL__,
          ...resourceUrl,
        };
      }
      console.debug('jsBridgeInterface setResourceUrl done');
    }

    console.debug('jsBridgeInterface webviewReady resolve');
    window.__WEBVIEW_READY_RESOLVE__();
  };

  const setupWebAppFunctions = () => {
    console.debug('jsBridgeInterface setupWebAppFunctions start');
    if (!window.WebApp) {
      console.debug(
        'jsBridgeInterface setupWebAppFunctions window.WebApp is null'
      );
      window.WebApp = {};
    }

    const functions = {
      getRefreshToken,
      setResourceUrl,
    };

    Object.entries(functions).forEach(([name, func]) => {
      if (!window.WebApp[name]) {
        window.WebApp[name] = func;
      }
    });

    console.debug('jsBridgeInterface setupWebAppFunctions done');
  };

  setupWebAppFunctions();

  if (window.WebApp?.remoteConfig) {
    setResourceUrl(window.WebApp.remoteConfig);
  } else {
    window.addEventListener(
      'flutterInAppWebViewPlatformReady',
      () => {
        console.debug('jsBridgeInterface flutterInAppWebViewPlatformReady');
        setResourceUrl(window.WebApp.remoteConfig);
      },
      { once: true }
    );
  }

  console.debug('jsBridgeInterface jsBridgeReady resolve');
  window.__JS_BRIDGE_READY_RESOLVE__();
}

export const hasWebviewCallHandler = () => {
  return isOnWebviewApp && window.WebApp?.callHandler;
};

export const callWebviewHandler = (name, ...args) => {
  if (hasWebviewCallHandler()) {
    window.WebApp.callHandler(name, ...args);
  }
};
